import React from 'react';
import Modal from './Modal';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Informativa Privacy GDPR 679/2016"
      size="large"
      showCloseButton={true}
      closeOnBackdropClick={true}
      closeOnEscape={true}
    >
      <div className="prose prose-sm max-w-none dark:prose-invert">
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Informativa all'interessato sul trattamento dei dati personali ai sensi dell'art. 13 del Regolamento (UE) 679/2016
            e consenso al trattamento dei dati personali
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">*** *** ***</p>
        </div>

        <div className="space-y-4 text-sm text-gray-700 dark:text-gray-300">
          <p>
            Ai sensi dell'art. 13 del Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio del 27 aprile 2016 
            sulla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera 
            circolazione di tali dati e che abroga la direttiva 95/46/CE (Regolamento generale sulla protezione dei dati, 
            di seguito per brevità anche indicato come "Regolamento" oppure "GDPR"), in relazione al trattamento dei Suoi 
            dati personali, la scrivente Unione Nazionale Autoscuole e Studi di Consulenza Automobilistica – UNASCA 
            (di seguito per brevità anche indicata come "Titolare"), la cui identità e i dati di contatto sono sotto indicati,
          </p>

          <p className="font-semibold text-gray-900 dark:text-white">La informa</p>
          <p>di quanto segue.</p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            1) Identità e dati di contatto del titolare del trattamento.
          </h4>
          <p>
            Titolare del trattamento dei Suoi dati personali ai sensi del Regolamento è l'Unione Nazionale Autoscuole e 
            Studi di Consulenza Automobilistica – UNASCA, in persona del Presidente pro tempore, con sede legale in 
            VIALE DI VAL FIORITA, 85 – 00144 ROMA, tel. 065421986, fax: 065916542, e-mail: unasca@unasca.it, 
            PEC: unasca@pec.unasca.it.
          </p>
          <p>
            Può rivolgersi al Titolare del trattamento scrivendo al citato indirizzo o inviando una e-mail al suindicate 
            indirizzo di posta elettronica.
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            2) Finalità del trattamento cui sono destinati i dati e base giuridica del trattamento.
          </h4>
          
          <h5 className="font-semibold text-gray-900 dark:text-white mt-4">
            a) Trattamento dei dati personali per finalità di perseguimento degli scopi statutari e allo svolgimento delle finalità associative
          </h5>
          <p>
            I dati personali da Lei direttamente conferiti o comunque raccolti dallo scrivente Titolare saranno trattati in 
            via esclusiva per il perseguimento degli scopi statutari e lo svolgimento delle finalità associative.
          </p>
          <p>
            Tutti i dati comunicati dall'interessato saranno trattati, pertanto, esclusivamente per gli adempimenti connessi 
            alle attività suindicate del Titolare e, altresì, per le finalità di invio di materiale informativo e newsletter 
            relative alle iniziative, studi, ricerche, comunicazioni e inviti per la partecipazione ad eventi, convegni, 
            iniziative di formazione, workshop promossi e/o partecipati dal Titolare attraverso strumenti tradizionali 
            (per esempio, posta cartacea e/o chiamata con operatore, etc.) e per il tramite di strumenti di comunicazione 
            elettronica (quali e-mail, SMS, etc.) e per l'inserimento delle anagrafiche nei database informatici dello 
            scrivente Titolare. La base giuridica del trattamento per la suddetta finalità è l'art. 6, paragrafo 1, lettera b) 
            del GDPR ("il trattamento è necessario all'esecuzione di un contratto di cui l'interessato è parte o all'esecuzione 
            di misure precontrattuali adottate su richiesta dello stesso"). I Suoi dati saranno trattati, inoltre, nel rispetto 
            dei principi, regolamenti e leggi, regolamenti e dalla normativa dell'UE. La base giuridica del trattamento per le 
            finalità suindicate è l'art. 6, paragrafo 1, lettera c), cit. ("il trattamento è necessario per adempiere un obbligo 
            legale al quale è soggetto il titolare del trattamento").
          </p>

          <h5 className="font-semibold text-gray-900 dark:text-white mt-4">
            b) Trattamento dei dati personali per finalità promozionali
          </h5>
          <p>
            I Suoi dati personali potranno, inoltre, essere trattati dallo scrivente Titolare qualora Lei presti il Suo specifico 
            consenso ai sensi dell'art. 7 del Regolamento, per finalità di informazione e promozioni commerciali di prodotti e 
            servizi promossi dal Titolare se attraverso strumenti tradizionali (per esempio, posta cartacea e/o chiamata con 
            operatore, etc.) e per il tramite di strumenti di comunicazione elettronica quali, a titolo meramente esemplificativo, 
            e-mail, fax, SMS, MMS, APP o social media.
          </p>
          <p>
            La base giuridica del trattamento per la suddetta finalità è il consenso dell'interessato ai sensi dell'art. 6, 
            paragrafo 1, lettera a), cit. ("l'interessato ha espresso il consenso al trattamento dei propri dati personali per 
            una o più specifiche finalità").
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            3) Modalità di trattamento dei dati.
          </h4>
          <p>
            Il trattamento dei Suoi dati personali, potrà essere effettuato con l'ausilio di mezzi elettronici o comunque 
            automatizzati e, in specie, per il tramite di database e banche dati di proprietà dello scrivente (o in uso allo 
            scrivente), con modalità e procedure strettamente necessarie al perseguimento delle finalità sopra descritte. 
            Saranno, altresì, utilizzati, i dati relativi e necessari nelle comunicazioni a distanza (a titolo esemplificativo: 
            e-mail, fax, SMS, MMS, APP e social media). In relazione alle suindicate finalità, il trattamento dei Suoi dati 
            personali avverrà mediante strumenti manuali, informatici e telematici per la mera realizzazione delle finalità 
            stesse e, comunque, in modo da garantire la sicurezza e la riservatezza.
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            4) Eventuali destinatari e le eventuali categorie di destinatari dei dati personali.
          </h4>
          <p>
            Il trattamento dei dati personali sarà effettuato a mezzo di soggetti espressamente e specificatamente designati 
            dal Titolare che operano presso la sede del dello stesso (sede legale e/o sede operativa) ovvero presso – ove 
            esistenti – uo periferiche (sedi secondarie, sedi distaccate, etc.). Tali soggetti tratteranno i Suoi dati 
            conformemente alle istruzioni ricevute dal Titolare, in qualità di responsabili del trattamento ai sensi dell'art. 28 
            cit. e/o quali soggetti espressamente designati al trattamento dei dati nei termini previsti dal Regolamento e dalla 
            normativa nazionale di adeguamento (D.Lgs. n. 101 del 2018).
          </p>
          <p>
            I dati personali dell'interessato non sono soggetti a diffusione.
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            5) Trasferimento dei dati personali a un paese terzo o a un'organizzazione internazionale.
          </h4>
          <p>
            Nessun dato personale dell'interessato verrà trasferito a un paese terzi o ai fuori della Unione Europea o ad 
            Organizzazioni internazionali.
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            6) Periodo di conservazione dei dati personali.
          </h4>
          <p>
            I dati personali oggetto di trattamento saranno conservati in ottemperanza a quanto disposto dall'art. 5, paragrafo 1, 
            lett. e), cit. in una forma che consenta l'identificazione degli interessati per un arco di tempo non superiore al 
            conseguimento delle finalità sopraindicate per le quali i dati personali sono trattati.
          </p>
          <p>I dati personali sono conservati secondo i seguenti criteri:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>per tutta la durata del rapporto associativo;</li>
            <li>per le finalità promozionali di cui al punto 2, lett. a), salvo revoca del consenso prestato, per non oltre 24 mesi decorrenti dalla cessazione del rapporto associativo;</li>
            <li>per il tempo strettamente necessario all'adempimento degli obblighi di conservazione previsti dalla normativa civilistica, contabile e fiscale (di regola, 10 anni dalla cessazione del rapporto associativo).</li>
          </ul>
          <p>Al termine del periodo di conservazione i dati personali saranno cancellati, ovvero resi anonimi.</p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            7) Diritti dell'interessato.
          </h4>
          <p>
            Ai sensi degli artt. 15 e ss. del Regolamento, l'interessato ha il diritto di chiedere al Titolare del trattamento:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>l'accesso ai propri dati personali;</li>
            <li>la rettifica o la cancellazione degli stessi o la limitazione del trattamento che lo riguardano;</li>
            <li>l'opposizione al trattamento;</li>
            <li>la portabilità dei dati nei termini di cui all'art. 20 cit.;</li>
            <li>qualora il trattamento sia basato sull'articolo 6, paragrafo 1, lettera a), oppure sull'articolo 9, paragrafo 2, lettera a), ovvero su un consenso prestato in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca.</li>
          </ul>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            8) Obbligo di fornire i dati personali.
          </h4>
          <p>
            La comunicazione dei dati personali da parte Sua e il conseguente trattamento da parte dello scrivente sono necessari 
            per l'iscrizione all'Associazione, per la prosecuzione e per la corretta gestione del rapporto associativo in parola.
          </p>
          <p>
            L'eventuale rifiuto, da parte Sua, a fornire i dati personali richiesti potrà causare, da parte dello scrivente, 
            l'impossibilità di instaurare o proseguire il rapporto associativo in essere.
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            9) Esistenza di un processo decisionale automatizzato, compresa la profilazione.
          </h4>
          <p>
            Ai sensi dell'art. 13, paragrafo 2, lettera f) del GDPR, si informa che i dati personali raccolti non saranno oggetto 
            di alcun processo decisionale automatizzato, compresa la profilazione di cui all'art. 22, paragrafi 1 e 4 del Regolamento.
          </p>

          <h4 className="text-base font-semibold text-gray-900 dark:text-white mt-6">
            10) Trattamento dei dati personali per una finalità diversa.
          </h4>
          <p>
            Qualora il Titolare del trattamento intenda trattare ulteriormente i dati personali per una finalità diversa da quella 
            per cui essi sono stati raccolti, prima di tale ulteriore trattamento, fornirà all'interessato informazioni in merito 
            a tale diversa finalità e ogni ulteriore informazione pertinente di cui all'art. 13, paragrafo 2 del Regolamento.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={onClose}
            className="w-full bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Chiudi
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;

